<template>
  <div class="container package">
    <section id="editContent" class="columnContainer">
      <!-- 서비스 리스트 -->
      <div class="innerColumn">
        <div v-if="isService">
          <h1 class="contentTitle">패키지 > 서비스</h1>
          <div class="packageServiceList">
            <button
              type="button"
              class="item btnAdd"
              @click="setDetail('new')">
              +
            </button>
            <div
              v-for="(item, index) in filteredList"
              :key="index"
              :data-type="item.linkType"
              class="item"
              :class="{disabled: !item.isActive}"
              @click="setDetail(item)">
              <div class="name">{{ item.title }}</div>
              <div class="components">
                <div
                  v-for="(comp, index) in item.components"
                  :key="index"
                  class="componentItem">
                  {{ comp }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="isService === false" class="noData">{{ locale.alert_not_support }}</div>
        <div v-else class="noData">{{ locale.message_loading_data }}</div>
      </div>
      <!-- //서비스 리스트 -->
      <!-- 검색 -->
      <!-- <div class="innerSide"><div class="sideBox">
        <div v-if="isService">
          <div class="innerItem filterInput">
            <p class="innerTitle toCapitalize f_medium">{{locale.search}}</p>
            <input
              type="text"
              class="input"
              :placeholder="locale.search_placeholder"
              v-model="filter.word">
          </div>
          <div class="treeList">
            <div
              v-for="(item, index) in linkTypes"
              :key="index"
              class="item">
              <div class="option">
                <span class="checkbox">
                  <input
                    type="checkbox"
                    name="checkLinkTypes"
                    :id="`check_linkType_${item}`"
                    :value="item"
                    v-model="filter.linkType">
                  <label
                    :for="`check_linkType_${item}`">
                    <span class="blind">check</span>
                  </label>
                </span>
                <div class="listLabel">
                  <div class="input">{{ locale[item] }}</div>
                </div>
              </div>
            </div>
            <div class="group unCategorized">
              <div class="item">
                <div class="option">
                  <span class="checkbox">
                    <input
                      type="checkbox"
                      name="checkLinkTypes"
                      id="check_linkType_unCategorized"
                      v-model="includeUnLink">
                    <label
                      for="check_linkType_unCategorized">
                      <span class="blind">check</span>
                    </label>
                  </span>
                  <div class="listLabel">
                    <div class="input">uncategorized</div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div></div> -->
      <!-- //검색 -->
    </section>
    <div id="setContent">
      <div>
        <div class="innerItem">
          <button type="button" class="btn btnFull btnPrimary" :disabled="!isService" @click="onSave">{{locale.save}}</button>
        </div>
        <div class="innerItem">
          <button type="button" class="btn btnFull" :disabled="!isService" @click="setMyPackage(true)">마이패키지 설정</button>
        </div>
      </div>
    </div>
    <ServiceDetail
      v-if="detail"
      :locale="locale"
      :detail="detail"
      :checkedInfo="checkedInfo"
      @apply="applyDetail"
      @add="addDetail"
      @delete="deleteDetail"
      @close="closeDetail" />
    <MyPackage
      v-if="mypackage"
      :locale="locale"
      :serviceList="serviceList"
      @apply="applyMyPackage"
      @close="closeMyPackage" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import ServiceDetail from '@/components/Package/ServiceDetail'
import MyPackage from '@/components/Package/MyPackage'

export default {
  name: 'Package',
  props: [
    'locale'
  ],
  components: {
    ServiceDetail,
    MyPackage
  },
  computed: {
    ...mapGetters({
      settingData: 'setting/getData',
      getPackageResultData: 'package/getPackageResultData'
    }),
    lang () {
      return this.settingData.lang
    },
    filteredList () {
      const list = this.serviceList && this.serviceList.filter(x => {
        return x
      })
      return list.sort((a, b) => {
        return a.createat > b.createat ? -1 : a.createat < b.createat ? 1 : 0
      })
    },
    checkedInfo () {
      const list = this.serviceList || []
      const checked = list.map(x => {
        return {
          type: x.linkType,
          id: x.linkUUID
        }
      })
      function arrToObj (arr) {
        return arr.reduce((result, item) => {
          if (!result[item.type]) {
            result[item.type] = [] // 해당 type이 없으면 초기화
          }
          result[item.type].push(item.id) // id 추가
          return result
        }, {})
      }
      return arrToObj(checked)
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    let defaultItem = {
      psId: UNIQUE.mid(),
      index: null,
      title: '',
      components: [],
      linkType: 'reservation',
      linkUUID: '',
      linkURL: {},
      linkContent: this.$store.getters['setting/getLangValues'](),
      isActive: true
    }
    return {
      defaultItem,
      linkTypes: [
        'page',
        'reservation',
        // 'product'
      ],
      filter: {
        word: '',
        linkType: [
          'page',
          'reservation'
        ]
      },
      includeUnLink: true,
      detail: null,
      mypackage: false,
      serviceList: null,
      isService: null
    }
  },
  methods: {
    async init () {
      const res = await this.$store.dispatch('package/getMyPackageSetting')
      if (res && res.status === 200) {
        const list = res && res.message && res.message.payload
        this.isService = list || []
        this.serviceList = list.map(x => {
          return {
            ...x,
            linkType: x.linkType && x.linkType.toLowerCase()
          }
        })
      } else {
        const status = (res && res.data && res.data.status) || 500
        const message = this.locale[status]
        alert(message)
        this.isService = false
      }
    },
    setServiceItem (data) {
      function getLinkData(linkData) {
        const isTicket = linkData.type === 'func' && linkData.funcId === 'ticket'
        let linkUUID
        let linkURL

        if (isTicket) {
          linkUUID = linkData.ticketFunc
        } else {
          switch (linkData.type) {
            case 'page':
              linkUUID = linkData.pageId
              break
            case 'product':
              linkUUID = linkData.productId
              break
            case 'reservation':
              linkUUID = linkData.reservationId
              break
            case 'shortcut':
              linkUUID = linkData.shortcutId
              break
            case 'outlink':
              linkURL = linkData.url
              break
          }
        }

        return {
          linkType: isTicket ? 'ticket' : linkData.type,
          ...(linkUUID && { linkUUID }),
          ...(linkURL && { linkURL })
        };
      }

      this.serviceList = this.serviceList.map(x => {
        const item = x.psId === data.psId
        return item ? {
          ...data,
          ...getLinkData(data.link)
        } : x
      }).map(x => {
        delete x.link
        return x
      })
    },
    setDetail (detail) {
      this.detail = detail
    },
    addDetail (detail) {
      const maxIndex = this.serviceList.reduce((max, item) => {
        return item.index > max ? item.index : max
      }, 0)
      detail.index = maxIndex + 1
      this.serviceList.unshift(detail)
      this.setServiceItem(detail)
      this.closeDetail()
      this.onSave(true)
    },
    applyDetail (detail) {
      this.setServiceItem(detail)
      this.closeDetail()
      this.onSave(true)
    },
    deleteDetail (psId) {
      this.serviceList = this.serviceList.filter(x => x.psId !== psId)
      this.closeDetail()
      this.onSave(true)
    },
    closeDetail () {
      this.setDetail(null)
    },
    setMyPackage () {
      this.mypackage = true
    },
    applyMyPackage (data) {
      this.serviceList = data
      this.closeMyPackage()
    },
    closeMyPackage () {
      this.mypackage = false
    },
    async onSave (directSave) { // 컨펌없이 세이브
      if (this.serviceList) {
        if (directSave || window.confirm(this.locale.confirm_save)) {
          this.$store.commit('onLoading', true)
          const serviceList = this.serviceList.map(x => {
            return {
              ...x,
              linkType: x.linkType.toUpperCase()
            }
          })
          const res = await this.$store.dispatch('package/setMyPackageSetting', serviceList)
          if (res && res.status === 200) {
            const error = res.message && res.message.error
            if (!(error && error.length > 0)) {
              alert(this.locale.complete_save)
            } else {
              alert(error)
            }
          }
          this.$store.commit('onLoading', false)
        }
      } else {
        alert(this.locale.alert_system_error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding-top: 100px;
  padding-bottom: 15px;
  text-align: center;
  font-size: 1.8em;
  color: $color-lgrey;
}
</style>
